var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import pureUA from '@arsenal/arsenal/modules/pureUA';
import { request } from '../fetch';
import { parseQuery, isIOS, getAppType as getAppTypeString } from '../../utils';
import { getBrowserType, getAppType, SHARK_EVENTS as _SHARK_EVENTS, } from './tools';
// OS 信息
var OS = null;
// 风控事件枚举
export var SHARK_EVENTS = _SHARK_EVENTS;
// 获取风控参数
export var getSharkParams = function (_a) {
    var event = _a.event, _b = _a.app_id, app_id = _b === void 0 ? '' : _b, _c = _a.app_name, app_name = _c === void 0 ? '' : _c, _d = _a.activity_id, activity_id = _d === void 0 ? '' : _d, _e = _a.header, header = _e === void 0 ? {} : _e, _f = _a.webheader, webheader = _f === void 0 ? {} : _f, _g = _a.params, params = _g === void 0 ? {} : _g;
    var query = parseQuery();
    var timeZoneName = null;
    var networkType = null;
    try {
        timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    catch (e) { }
    if (navigator.connection) {
        networkType = navigator.connection.effectiveType;
    }
    if (!OS) {
        var _h = pureUA(navigator.userAgent).os, os = _h === void 0 ? {} : _h;
        OS = os;
    }
    var sharkParams = {
        header: __assign(__assign(__assign({}, query), { server_id: query.server_id, role_id: query.role_id, app_channel: query.channel || query.channel_op, host_app_id: app_id || query.aid, app_id: app_id || query.aid, app_name: app_name, app_version: query.version_name || '0.0.0', gsdk_version: query.gsdk_version || '0.0.0', app_language: query.sdk_language || navigator.language, device_id: query.device_id, device_model: query.device_type, os_name: isIOS() ? 'ios' : 'android', os_version: OS.version || query.os_version || '0.0.0', network_type: networkType, user_unique_id: query.open_id, time: Date.now(), event: event, user_is_auth: query.open_id ? true : false }), header),
        webheader: __assign({ app_id: app_id, activity_type: -1, activity_id: activity_id, activity_link_id: query.from_source || query.to_app_type, user_agent: navigator.userAgent, referer: document.referrer, cookie_enabled: navigator.cookieEnabled, screen_width: window.screen.width, screen_height: window.screen.height, browser_type: getBrowserType(), browser_language: navigator.language, browser_platform: navigator.platform, browser_name: navigator.appCodeName, browser_version: navigator.appVersion, browser_online: navigator.onLine, timezone_name: timeZoneName, time: Date.now() }, webheader),
        params: __assign({ inf_from: getAppType(), did: query.device_id, aid: app_id, app_name: app_name, device_platform: query.device_platform, user_agent: navigator.userAgent }, params),
    };
    if (event) {
        sharkParams['event'] = event;
    }
    return sharkParams;
};
export var getExtraBodyParams = function (app_id) {
    var query = parseQuery();
    return {
        channel_app_id: app_id + '',
        launch_from: getAppTypeString(),
        launch_way: '',
        page_id: location.origin + location.pathname,
        url: location.href,
        login_type: query.open_id ? 'gsdk' : 'passport',
    };
};
// 上报风控事件
export var sharkReport = function (event, _a) {
    var app_id = _a.app_id, app_name = _a.app_name, activity_id = _a.activity_id, _b = _a.dataParams, dataParams = _b === void 0 ? {} : _b, _c = _a.header, header = _c === void 0 ? {} : _c, _d = _a.webheader, webheader = _d === void 0 ? {} : _d, _e = _a.params, params = _e === void 0 ? {} : _e, _f = _a.useSharkSign, useSharkSign = _f === void 0 ? true : _f;
    if (typeof activity_id !== 'string') {
        throw new Error('activity_id 必须是string类型！');
    }
    var query = parseQuery();
    var sharkParams = getSharkParams({
        event: event,
        app_id: app_id,
        app_name: app_name,
        activity_id: activity_id,
        header: header,
        webheader: webheader,
        params: params,
    });
    var host = location.origin || '';
    var bodyParams = getExtraBodyParams(app_id);
    request({
        url: "".concat(host, "/act/").concat(app_id, "/shark_report"),
        method: 'post',
        data: __assign(__assign(__assign(__assign({}, query), bodyParams), dataParams), { activity_id: activity_id, shark_params: sharkParams }),
        useSharkSign: useSharkSign,
        timeout: 60000,
    }).then(function (res) {
        return res;
    }).catch(function () { }); // request 的请求错误会throw，但是风控上报并不需要关注结果，这里catch防止线上报警。
};
//# sourceMappingURL=index.js.map